module.exports = __webpack_public_path__ + "img/mision.da1daf29.svg";